import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

export function InfoTip({ text, size = 13, testId }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          aria-label="Help"
          style={{ background: "transparent", border: "none", padding: 0, cursor: "help", color: "var(--tmuted)", display: "inline-flex", lineHeight: 0 }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "var(--orange)")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--tmuted)")}
        >
          <HelpCircle size={size} />
        </button>
      </TooltipTrigger>
      <TooltipContent
        className="font-body"
        style={{ maxWidth: 248, background: "var(--panel)", color: "var(--tprimary)", border: "1px solid var(--cardhover)", fontSize: 12, lineHeight: 1.55, padding: "8px 10px" }}
      >
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
